export default __webpack_public_path__ + "static/media/screen2.dace5bfb.png";